const API_BASE_URL = '/api/prisme';

export interface TemplateLinksResponse {
  templateId: string;
  documentTypeCodes: string[];
}

export async function getTemplateDocumentLinks(templateId: string): Promise<string[]> {
  const response = await fetch(`${API_BASE_URL}/intake-template-links/${encodeURIComponent(templateId)}`);
  if (!response.ok) {
    throw new Error('Erreur lors de la récupération des liens template / types de documents');
  }
  const data: TemplateLinksResponse = await response.json();
  return data.documentTypeCodes || [];
}

export async function setTemplateDocumentLinks(templateId: string, documentTypeCodes: string[]): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/intake-template-links/${encodeURIComponent(templateId)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ documentTypeCodes }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Erreur lors de la mise à jour des liens template / types' }));
    throw new Error(error.error || 'Erreur lors de la mise à jour des liens template / types');
  }
}









